import clsx from "clsx";
import {
  ChevronFirst,
  ChevronLast,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";

const PaginationButton = ({ type, ...props }) => {
  let icon = null;

  if (type === "first") {
    icon = <ChevronFirst size={16} strokeWidth={3} />;
  } else if (type === "previous") {
    icon = <ChevronLeft size={16} strokeWidth={3} />;
  } else if (type === "next") {
    icon = <ChevronRight size={16} strokeWidth={3} />;
  } else if (type === "last") {
    icon = <ChevronLast size={16} strokeWidth={3} />;
  }

  return (
    <button
      {...props}
      className="p-2 text-[#2a5caa] hover:bg-gray-50 border-2 border-gray-300 rounded-md cursor-pointer transition-colors duration-200 ease-in-out"
    >
      {icon}
    </button>
  );
};

const Pagination = ({
  page,
  totalPages,
  onChangePage,
  className,
  ...props
}) => {
  return (
    <div className={clsx("flex items-center gap-2", className)} {...props}>
      <span>
        Page {page} of {totalPages}
      </span>
      <div className="flex gap-2 m-2">
        <PaginationButton
          type="first"
          onClick={() => onChangePage(1)}
        ></PaginationButton>
        <PaginationButton
          type="previous"
          onClick={() => onChangePage(page - 1 > 1 ? page - 1 : 1)}
        ></PaginationButton>
        <PaginationButton
          type="next"
          onClick={() =>
            onChangePage(page + 1 < totalPages ? page + 1 : totalPages)
          }
        ></PaginationButton>
        <PaginationButton
          type="last"
          onClick={() => onChangePage(totalPages)}
        ></PaginationButton>
      </div>
    </div>
  );
};

export default Pagination;
